// extracted by mini-css-extract-plugin
module.exports =  {"avatarUploader":"avatarUploader__sm4Hd"};